export type EntrancePhase = "idle" | "center" | "docking" | "docked";
export type EntranceEvent =
  | "enter"
  | "digestDone"
  | "dwellElapsed"
  | "letsGo"
  | "dockDone"
  | "reducedMotion";

export function nextEntrancePhase(
  cur: EntrancePhase,
  ev: EntranceEvent
): EntrancePhase {
  if (cur === "docked") return "docked";

  switch (ev) {
    case "enter":
      return cur === "idle" ? "center" : cur;
    case "letsGo":
      return cur === "center" ? "docking" : cur;
    case "dwellElapsed":
      return cur === "center" ? "docking" : cur;
    case "digestDone":
      return cur;
    case "dockDone":
      return cur === "docking" ? "docked" : cur;
    case "reducedMotion":
      return cur === "center" || cur === "docking" ? "docked" : cur;
    default:
      return cur;
  }
}
